export enum ReportStatus {
    wait = 'wait',
    in_progress = 'in_progress',
    done = 'done',
    fail = 'fail',
}



// WEBPACK FOOTER //
// /app/src/app/types/api-response/report/report-status.ts